import { glow } from '../effects';
import baseTheme from '../baseTheme';
var MuiCheckbox = {
    /* your custom class style overrides here */
    root: {
        width: baseTheme.typography.pxToRem(20),
        height: baseTheme.typography.pxToRem(20),
        margin: baseTheme.spacing(1),
        borderWidth: '2px',
        borderStyle: 'solid',
        borderRadius: '4px',
        fontSize: baseTheme.typography.pxToRem(16),
        '&.Mui-checked': {
            backgroundColor: baseTheme.palette.secondary.main,
            color: baseTheme.palette.secondary.contrastText,
        },
    },
    colorSecondary: {
        borderColor: baseTheme.palette.grey[300],
        '&:hover': {
            backgroundColor: baseTheme.palette.action.hover,
        },
        '&.Mui-checked': {
            backgroundColor: baseTheme.palette.secondary.main,
            borderColor: baseTheme.palette.secondary.main,
            color: baseTheme.palette.secondary.contrastText,
            '&:hover': glow({
                backgroundColor: baseTheme.palette.secondary.main,
            }, true),
            '&.Mui-disabled': {
                borderColor: baseTheme.palette.grey[400],
                color: baseTheme.palette.common.white,
                backgroundColor: baseTheme.palette.grey[400],
            },
        },
        '&.Mui-disabled': {
            backgroundColor: baseTheme.palette.grey[200],
            borderColor: baseTheme.palette.grey[400],
        },
        '&:not(.Mui-checked):not(.Mui-disabled)': {
            backgroundColor: baseTheme.palette.common.white,
        },
    },
};
export default MuiCheckbox;
//# sourceMappingURL=MuiCheckbox.js.map